import { Key, RowSelectMethod, SelectionSelectFn } from 'antd/es/table/interface';
import React from 'react';

import useDynamicSelector from '../hooks/useDynamicSelector';
import { ActionsType } from '../types';
import TableDb from './tableDb';

interface IWrapperTableDb {
    actions?: ActionsType[];
    sizeOfPage?: string[];
    renderDataColumn?: any;
    heightTable?: number;
    onSelectionChange?: (
        selectedRowKeys: Key[],
        selectedRows: any[],
        info: {
            type: RowSelectMethod;
        },
    ) => void;
    onSelect?: SelectionSelectFn<any>;
    defaultHiddenColumn?: string[];
}

const WrapperTableDb: React.FC<IWrapperTableDb> = ({ actions = [], ...RestProps }) => {
    const count = useDynamicSelector('table', 'count');
    const dataRows = useDynamicSelector('table', 'dataRows');
    const columns = useDynamicSelector('table', 'columns');

    return (
        <TableDb
            connectionId={''}
            columns={columns}
            dataRows={dataRows}
            count={count}
            loading={true}
            actions={actions}
            {...RestProps}
        />
    );
};

export default WrapperTableDb;
